import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import Moment from "react-moment";
import SplitPane from "react-split-pane";
import { studyDatasetsServices } from "../../../../APIServices/studyDatasetsServices";
import { useParams } from "react-router";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import Pagination from "../../../Pagination";

const TransferActivities = ({ tableRef, onMouseDown, transferId }) => {
  let { studyId } = useParams();
  const [transferedList, setTransferedList] = useState([]);
  const [transferedCount, setTransferedCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(transferedCount / itemsPerPage);

  const getStudyDatasetTransferedHistory = async () => {
    setLoading(true)
    let data = await studyDatasetsServices.getStudyDatasetTransferedHistory(
      studyId,
      transferId,
      pageNumber,
      itemsPerPage
    )
    setTransferedList(data?.data || []);
    setTransferedCount(data?.count || 0);
    setLoading(false)
  }

  useEffect(() => {
    getStudyDatasetTransferedHistory();
  }, [pageNumber, itemsPerPage, studyId, transferId])
  return (
    <>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        style={{ height: "-webkit-fill-available" }}
      >
        {loading ? (
         <PageLoader/>
        ) : transferedCount === 0 ? (
          <NoDataFoundTable MSG="History not found" />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table" hover striped>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  <th onMouseDown={(e) => onMouseDown(e, 0)} className="text-center" style={{width: 45}}>Sr.</th>
                  <th onMouseDown={(e) => onMouseDown(e, 1)}>Emails</th>
                  <th onMouseDown={(e) => onMouseDown(e, 2)}>Datasets</th>
                  <th onMouseDown={(e) => onMouseDown(e, 3)}>Transfered Date | Time</th>
                </tr>
              </thead>
              <tbody>
                {transferedList.map((item, index) => (
                  <tr className="CP" key={index}>
                    <td className="text-center">{index + 1 + startIndex}</td>
                    <td>
                      {(item?.emails || []).map((email, index) => (
                        <React.Fragment key={index}>
                          {email},
                          <br />
                        </React.Fragment>
                      ))}
                    </td>
                    <td>
                      {(item?.datasets || []).map((dataset, index) => (
                        <React.Fragment key={index}>
                          {dataset?.formName},
                          <br />
                        </React.Fragment>
                      ))}
                    </td>
                    <td>
                      <Moment format="DD MMM YYYY | HH:mm" withTitle>
                        {item?.createdAt}
                      </Moment>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={transferedCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
    </>
  );
};

export default TransferActivities;
